import React from "react";
import "./WhatsAppButton.css";
import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP_CONFIG } from "../../../config/WhatsappConfig";

const WhatsAppButton = ({ eventType = "default" }) => {
  const config = WHATSAPP_CONFIG[eventType] || WHATSAPP_CONFIG.default;

  if (!config.enabled) return null;

  const whatsappLink = `https://wa.me/${
    config.phoneNumber
  }?text=${encodeURIComponent(config.message)}`;

  return (
    <a
      href={whatsappLink}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp size={30} />
    </a>
  );
};

export default WhatsAppButton;
